import {
  CardSelect,
  CardSelectContent,
  CardSelectTrigger,
  DropsButton,
} from "shared/components/Spor";
import { AdminLinkItem } from "features/Header/Menu/adminLinks/AdminLinks";
import { useTranslation } from "react-i18next";
import {
  CheckmarkFill18Icon,
  LanguageOutline24Icon,
} from "@vygruppen/spor-icon-react";
import { log, LogLevel } from "logging/datadogBrowserLogs";
import { useState } from "react";

export const LanguageSwitch = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng).catch((error: Error) => {
      log(
        LogLevel.error,
        "LanguageSwitch",
        `Could not switch language. Error: ${error.message} `,
      );
    });
    localStorage.setItem("Language", lng);
  };

  return (
    <AdminLinkItem>
      <CardSelect
        open={isOpen}
        onOpenChange={(details) => setIsOpen(details.open)}
      >
        <CardSelectTrigger withChevron icon={<LanguageOutline24Icon />}>
          {i18n.language === "no" ? t("Norsk") : t("Svensk")}
        </CardSelectTrigger>
        <CardSelectContent justifySelf="center" width="fit-content">
          <DropsButton
            variant="ghost"
            rightIcon={i18n.language === "no" ? <CheckmarkFill18Icon /> : null}
            onClick={() => {
              changeLanguage("no");
              setIsOpen(false);
            }}
          >
            {t("Norsk", { lng: "no" })}
          </DropsButton>
          <DropsButton
            variant="ghost"
            rightIcon={i18n.language === "se" ? <CheckmarkFill18Icon /> : null}
            onClick={() => {
              changeLanguage("se");
              setIsOpen(false);
            }}
          >
            {t("Svensk", { lng: "se" })}
          </DropsButton>
        </CardSelectContent>
      </CardSelect>
    </AdminLinkItem>
  );
};
